/* ==========================================================================
   Zisabo Google Reviews Widget
   Reads cached Google review data (assets/google-reviews-data.json) and
   renders:
     - #zw-google-badge   (small footer badge)
     - #zw-reviews-banner (homepage review carousel)
   ========================================================================== */
(function () {
  "use strict";

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str == null ? "" : String(str);
    return div.innerHTML;
  }

  function starsHtml(rating) {
    var pct = Math.max(0, Math.min(5, Number(rating) || 0)) / 5 * 100;
    return (
      '<span class="zw-stars" aria-hidden="true">' +
      '<span class="zw-stars__fill" style="width:' + pct + '%"></span>' +
      "</span>"
    );
  }

  function initials(name) {
    if (!name) return "?";
    var parts = String(name).trim().split(/\s+/);
    var first = parts[0] ? parts[0][0] : "";
    var second = parts.length > 1 ? parts[1][0] : "";
    return (first + second).toUpperCase();
  }

  var GOOGLE_G_SVG =
    '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
    '<path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"/>' +
    '<path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.32-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"/>' +
    '<path fill="#FBBC05" d="M11.68 28.18A13.94 13.94 0 0 1 10.96 24c0-1.45.25-2.86.72-4.18v-5.7H4.34A21.96 21.96 0 0 0 2 24c0 3.55.85 6.91 2.34 9.88l7.34-5.7z"/>' +
    '<path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.34 5.7c1.74-5.2 6.59-9.07 12.32-9.07z"/>' +
    "</svg>";

  function renderBadge(root, data) {
    if (!data || !data.rating) {
      root.style.display = "none";
      return;
    }
    var url = data.google_maps_url || data.write_review_url || "#";
    root.setAttribute("href", url);
    root.innerHTML =
      '<span class="zw-google-badge__logo">' + GOOGLE_G_SVG + "</span>" +
      '<span class="zw-google-badge__rating">' + escapeHtml(data.rating.toFixed(1)) + "</span>" +
      starsHtml(data.rating).replace('class="zw-stars"', 'class="zw-stars zw-google-badge__stars"') +
      '<span class="zw-google-badge__count">' + escapeHtml(data.user_ratings_total) + " reviews</span>";
  }

  function renderBanner(root, data) {
    if (!data || !data.reviews || !data.reviews.length) {
      root.setAttribute("data-state", "error");
      return;
    }

    var scoreEl = root.querySelector("[data-zw-score]");
    var starsEl = root.querySelector("[data-zw-stars]");
    var countEl = root.querySelector("[data-zw-count]");
    var ctaEl = root.querySelector("[data-zw-cta]");
    var cardsEl = root.querySelector("[data-zw-cards]");

    if (scoreEl) scoreEl.textContent = Number(data.rating).toFixed(1);
    if (starsEl) starsEl.innerHTML = starsHtml(data.rating);
      if (countEl) {
        countEl.textContent = data.user_ratings_total + " reviews on Google";
        if (data.google_maps_url) countEl.setAttribute("href", data.google_maps_url);
      }
    if (ctaEl && (data.write_review_url || data.google_maps_url)) {
      ctaEl.setAttribute("href", data.write_review_url || data.google_maps_url);
    }

    if (cardsEl) {
      cardsEl.innerHTML = data.reviews
        .map(function (review) {
          return (
            '<div class="zw-review-card">' +
              '<div class="zw-review-card__header">' +
                '<div class="zw-review-card__avatar">' + escapeHtml(initials(review.author_name)) + "</div>" +
                '<div class="zw-review-card__meta">' +
                  '<span class="zw-review-card__name">' + escapeHtml(review.author_name) + "</span>" +
                  starsHtml(review.rating) +
                  '<span class="zw-review-card__time">' + escapeHtml(review.relative_time_description) + "</span>" +
                "</div>" +
              "</div>" +
              '<p class="zw-review-card__text">' + escapeHtml(review.text) + "</p>" +
            "</div>"
          );
        })
        .join("");
    }

    root.setAttribute("data-state", "loaded");
  }

  function init() {
    if (window.__zwReviewsInit) return;
    window.__zwReviewsInit = true;

    var badge = document.getElementById("zw-google-badge");
    var banner = document.getElementById("zw-reviews-banner");
    var dataUrl =
      (banner && banner.getAttribute("data-zw-reviews-url")) ||
      (badge && badge.getAttribute("data-zw-reviews-url"));

    if (!dataUrl || (!badge && !banner)) return;

    fetch(dataUrl, { cache: "no-store" })
      .then(function (res) {
        if (!res.ok) throw new Error("Failed to load reviews data");
        return res.json();
      })
      .then(function (data) {
        if (badge) renderBadge(badge, data);
        if (banner) renderBanner(banner, data);
      })
      .catch(function () {
        if (badge) badge.style.display = "none";
        if (banner) banner.setAttribute("data-state", "error");
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
